import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectIsAuthenticated,
  selectUserRoleId,
} from "../../store/selectors/authSelectors";
import {
  getPostLoginRoute,
  EXTERNAL_ID_QUERY_PARAM,
} from "../../utils/routeUtils";

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * PublicRoute - redirects to the user's home page if already authenticated.
 * Used for login, registration, and other auth pages.
 * Honors externalId query param from external patient deep-links.
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userRoleId = useSelector(selectUserRoleId);
  const [searchParams] = useSearchParams();
  const externalId = searchParams.get(EXTERNAL_ID_QUERY_PARAM);

  if (isAuthenticated) {
    return (
      <Navigate to={getPostLoginRoute(userRoleId, externalId)} replace />
    );
  }

  return <>{children}</>;
};

export default PublicRoute;
